import PatientCallPage from '../pages/patient/call'
import PatientChatsPage from '../pages/patient/chats'
const routes = [
  {
    Component: PatientChatsPage,
    exact: true,
    path: 'chats',
  },
  {
    Component: PatientCallPage,
    exact: true,
    path: 'call',
  },
]

export default routes
